import React from "react";
import SealBadge from "@/components/SealBadge";
import { X } from "lucide-react";

/**
 * The Purchase Seal — an immediate, rewarding "Success Overlay" fired the moment a physical
 * mailing purchase (Boutique $9.99, Mailing Credit, or Credit Pack) is actually applied to a
 * card. Shows the finished artwork with a "Purchase Applied & Card Sealed" wax-seal stamp.
 */
const PurchaseSealOverlay = ({ open, onClose, card }) => {
  if (!open || !card) return null;
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-[hsl(38_30%_10%_/_0.65)] backdrop-blur-md p-4" data-testid="purchase-seal-overlay">
      <div className="surface rounded-[2rem] p-6 max-w-sm w-full text-center relative purchase-seal-pop">
        <button data-testid="purchase-seal-close" onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground"><X className="w-5 h-5" /></button>

        <div className="relative rounded-2xl overflow-hidden border border-border mb-4">
          <img src={`data:image/png;base64,${card.image_base64}`} alt="Sealed card" className="w-full h-52 object-cover" />
          <div className="absolute inset-0 flex items-center justify-center bg-black/25">
            <div className="seal-stamp-down">
              <SealBadge tier={card.seal_tier || "gold"} size={96} />
            </div>
          </div>
        </div>

        <h3 className="font-serif text-2xl mb-1" data-testid="purchase-seal-title">Purchase Applied &amp; Card Sealed</h3>
        <p className="text-sm text-muted-foreground mb-5">
          Your Maison Service Fee has been settled — {card.loved_one_name}&apos;s {card.occasion} card is queued for the Lob fulfillment desk.
        </p>
        <button data-testid="purchase-seal-done" onClick={onClose}
          className="w-full bg-gradient-to-r from-secondary to-primary text-white rounded-2xl py-3 hover:opacity-90">
          Wonderful
        </button>
      </div>
    </div>
  );
};

export default PurchaseSealOverlay;
